import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Modal from 'react-modal';
import { Loading } from '@curves/ui-base';

import { getLoadingData } from '@Redux/loading/selector';

const ShowLoading = () => {
    const { count = 0 } = useSelector(getLoadingData);
    const [open, setOpen] = React.useState(false);
    const isOpen = count > 0;

    const loadingMemo = useMemo(() => {
        return (
            <Modal isOpen={open} overlayClassName="modal-overlay" className="modal-content" ariaHideApp={false} onRequestClose={() => {}}>
                <Loading size={50} duration={700} />
            </Modal>
        );
    }, [open]);

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);

    return <React.Fragment>{loadingMemo}</React.Fragment>;
};

export default ShowLoading;
